module.exports = __webpack_public_path__ + "img/0_l.2979b7d3.jpg";